/**
 * Canonical funding-type mapping for the payment-processing feature.
 *
 * A batch's funding type is derived from its originator ID on the backend
 * (see eft-builder.service.js -> ORIGINATOR_CONFIGS):
 *   SPV -> SA12029944, MFT -> LMCRE0002C, DEB (Debenture) -> LMCRE0004C.
 *
 * This is the single frontend source for the three types and their display
 * labels. Use it everywhere in the feature (list filter, manual-transaction
 * dialog, ACH upload dialog) instead of re-declaring the list inline.
 */

export type FundingType = 'DEB' | 'MFT' | 'SPV';

export interface FundingTypeOption {
  value: FundingType;
  label: string;
}

/** Display order shown in dropdowns. */
export const FUNDING_TYPE_OPTIONS: readonly FundingTypeOption[] = [
  { value: 'SPV', label: 'SPV' },
  { value: 'MFT', label: 'MFT' },
  { value: 'DEB', label: 'DEBENTURE' },
] as const;

const FUNDING_TYPE_LABELS = new Map<string, string>(
  FUNDING_TYPE_OPTIONS.map((option) => [option.value, option.label]),
);

/** Resolves a funding-type code to its label; returns '-' when empty, or the raw code if unknown. */
export function fundingTypeLabel(value: string | null | undefined): string {
  if (!value) return '-';
  return FUNDING_TYPE_LABELS.get(value) ?? value;
}